import React from 'react';
import { List, ListItem, ListItemText, ListItemSecondaryAction } from './../../../themes/list'
import { Checkbox } from './../../../themes/input'

const renderItemsForPermission = ({ fields, meta: { error, submitFailed }, onChange }) => (

    <List style={{'width':'100%'}} disablePadding>
      {
        fields.map((entity, index) => (
          <ListItem key={ fields.get(index)._id } disableGutters divider>
            <ListItemText primary={ fields.get(index).name } secondary={ fields.get(index).description } />
            <ListItemSecondaryAction>
            { console.log(fields.get(index).name,fields.get(index).checked) }
              <Checkbox
                name={`${entity}.checked`}
                checked={ fields.get(index).checked }
                onChange={ (event: object, checked: boolean) => {
                    onChange(index, event.target.checked)
                  }
                }/>
            </ListItemSecondaryAction>
          </ListItem>
        ))
      }
    </List>

);

export default renderItemsForPermission;
